import React from 'react';
import { IconProps } from './model/IconInterface';

const BankIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 9l9-6 9 6" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="6" y1="12" x2="6" y2="18" /><line x1="10" y1="12" x2="10" y2="18" /><line x1="14" y1="12" x2="14" y2="18" /><line x1="18" y1="12" x2="18" y2="18" /><line x1="3" y1="21" x2="21" y2="21" />
    </svg>
  );
};

export default BankIcon;
